import { roles } from "../config/config";

export const articoliEventoViewPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
];

export const articoliEventoManagePermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
];

export const getArticoliEventoViewPermissions = (userIsAgente) => [
  ...articoliEventoViewPermissions,
  userIsAgente,
];
